import PptxGenJS from 'pptxgenjs';
import ITravelPassVipSlideData from '@app/types/data/slides/ITravelPassVipSlideData';
import { defaultViewPortPadding } from '@app/services/export/ppt/variables/constants';
import { gridColWidth } from '@app/services/export/ppt/utils/gridUtils';
import { PriceTable } from '@app/services/export/ppt/classes/PriceTable';
import AbstractOfferSlideProcessor, {
	IPptOfferSlideOptions
} from '@app/services/export/ppt/slides/AbstractOfferSlideProcessor';
import PowerPointPresentation from '@app/services/export/ppt/PowerPointPresentation';


export default class PowerPointTravelPassVipSlideProcessor extends AbstractOfferSlideProcessor<ITravelPassVipSlideData> {

	public constructor(slideData: ITravelPassVipSlideData, presentation: PowerPointPresentation) {
		const options: Partial<IPptOfferSlideOptions> = {
			imageWidth: defaultViewPortPadding.horizontal + gridColWidth(7)
		};

		super(slideData, presentation, options);
	}

	public async processSlideData(): Promise<void> {
		if (this.slideData.image) {
			await this.adjustImageDimensions(this.slideData.image);
		}

		this.updateSlideData({ visibleSvgGroup: 'default' });
		const { x, y, w } = this.getAvailableSpaceRectangle();
		const offerSlideBase: PptxGenJS.Slide = this.createOfferSlideBase();

		const priceTable = new PriceTable(
			offerSlideBase,
			{
				rows: [{ individuals: this.slideData.prices }]
			},
			{ x, y, w }
		);

		priceTable.create();
	}
}
